export const RecordScreenIcon = (
  <svg className="size-10" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_b_49_1018)">
      <rect x="6" y="6" width="60" height="60" rx="30" fill="currentColor" />
    </g>
    <path
      d="M35.965 47.6666C42.4083 47.6666 47.6317 42.4433 47.6317 36C47.6317 29.5567 42.4083 24.3333 35.965 24.3333C29.5217 24.3333 24.2983 29.5567 24.2983 36C24.2983 42.4433 29.5217 47.6666 35.965 47.6666Z"
      stroke="white"
      strokeWidth="2.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M36.0004 40.935C38.726 40.935 40.9354 38.7255 40.9354 36C40.9354 33.2745 38.726 31.065 36.0004 31.065C33.2749 31.065 31.0654 33.2745 31.0654 36C31.0654 38.7255 33.2749 40.935 36.0004 40.935Z"
      stroke="white"
      strokeWidth="2.25"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="36" cy="36" r="4" fill="white" fillOpacity="0.6" />
    <g opacity="0.1" filter="url(#filter1_f_49_1018)">
      <circle cx="35.5" cy="35.5" r="20.5" stroke="white" strokeWidth="2" />
      <circle cx="35.5" cy="35.5" r="20.5" stroke="white" strokeWidth="2" />
    </g>
    <g opacity="0.2" filter="url(#filter2_f_49_1018)">
      <circle cx="36" cy="36" r="34" stroke="white" strokeWidth="2" />
      <circle cx="36" cy="36" r="34" stroke="white" strokeWidth="2" />
    </g>
    <defs>
      <filter
        id="filter0_b_49_1018"
        x="-4.5"
        y="-4.5"
        width="81"
        height="81"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="5.25" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_49_1018" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_49_1018"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_f_49_1018"
        x="13"
        y="13"
        width="45"
        height="45"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_49_1018" />
      </filter>
      <filter
        id="filter2_f_49_1018"
        x="0"
        y="0"
        width="72"
        height="72"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_49_1018" />
      </filter>
    </defs>
  </svg>
);
